import styled from "styled-components"
import { mobile, medScreen, tablet } from "../../Responsive"

export const Container = styled.div`
    margin: 0 auto;
    padding: 0 20px;

    h1 {
        @media screen and (max-width: ${medScreen}) {
            font-size: var(--fontL);
        }
    }
`

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(350px, 1fr));
    grid-gap: 20px;

    ${tablet({ gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))" })}
    ${mobile({ gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))"})}
`